import defaultTheme from 'e100-react-components/lib/theme/defaultTheme';
import makeStyles from 'e100-react-components/lib/styles/makeStyles';
import createStyles from 'e100-react-components/lib/styles/createStyles';

import { checkIsActiveGoogleMap } from 'entities/map';

const useGlobalStyles = makeStyles(({ palette }) => createStyles({
  '@global': {
    html: {
      height: '100%'
    },
    body: {
      fontFamily: defaultTheme.typography.fontFamily,
      touchAction: 'none',
      height: '100%'
    },
    '#root': {
      height: '100%'
    },
    '.deck-widget-popover-arrow': {
      width: '28px !important',
      height: '8px !important',
      border: 'none !important',
      transform: 'translateX(-50%) !important',
      left: '50% !important',
      bottom: '-7px !important',
      backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAICAYAAADqSp8ZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAG5JREFUeAG9j0ENgDAMRX8dIGEScICVSZiESkACOMARcwAOyifZgcsCY4yXvOyy9qWChJl1fHrq6UAd6tjpTBcaRSRmfzLu6GTvGdMBZXAoWDkeNZwLfotdovogpviSm6iiBZmooiUputKNBhRyAJQ0HbHmHzsyAAAAAElFTkSuQmCC)'
    },
    '#deckgl-overlay': {
      zIndex: () => checkIsActiveGoogleMap() ? 99 : 'inherit'
    }
  }
}));

export default useGlobalStyles;
